// extracted by mini-css-extract-plugin
export default {"customHeading":"dataDisplay_customHeading__TsVsZ","customContent":"dataDisplay_customContent__uRrTx"};